"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getCdn;
var _functions = require("./functions");
/**
 * Module that provides utility functions to determine CDN
 *
 * @module cdn
 */

var CDN_ERROR = 'CDN_ERR';
var IS_REMOTE_FILE_REGEX = /http(s)?:\/\//;
var LOCAL = 'LOCAL';
function errorHandler() {
  return Promise.resolve(CDN_ERROR);
}
function getCdn(manifest) {
  if (!IS_REMOTE_FILE_REGEX.test(manifest)) {
    return Promise.resolve(LOCAL);
  }
  return (0, _functions.getFileServedFromCdn)(manifest).then(_functions.getHeaders).then(_functions.extractCdnFromHeaders)["catch"](errorHandler);
}